<div class="btn-group marginTopQuarterEm d-flex" role="group">
    <button type="button" title="New"       data-abbrev="" class="btn btn-secondary actionButton" (click)="add()"        *ngIf="methods.includes('add')"><span class="fas fa-plus"></span></button>
    <button type="button" title="Clear All" data-abbrev="" class="btn btn-secondary actionButton" (click)="clear()"      *ngIf="methods.includes('clear')"><span class="fas fa-exclamation-triangle"></span></button>
    <button class="btn btn-secondary dropup" ngbDropdown display="dynamic" placement="top-right" *ngIf="methods.includes('bulkImport') && hasImportTemplates">
        <div ngbDropdownToggle id="gridImportButtonDropUp" role="button" type="button" class="">
            <span class="fas fa-file-import" aria-hidden="true"></span>
            Import
        </div>
        <div ngbDropdownMenu aria-labelledby="gridImportButtonDropUp" class="dropdown-menu inherit-font-size paddingTop0 paddingBottom0">
            <a  class="dropdown-item"
                wackadooFileUpload
                eventHandler="{{ eventHandler }}"
                action="bulkImport"
                [parms]="{fileExtension:'txt'}"
                [validExtensions]="'txt'"
                successTitle="File Import Complete"
                confirmTitle="IMPORTANT! You are about to import a large number of resources."
                confirmMessage="These resources will be ADDED to the list on the {{ eventHandler }} page.\n\nThis is a BULK-ADD operation which WILL generate duplicate entries if the same data is imported multiple times. (This import process does NOT replace existing items! Though the format of the file must match what you get from the Export function, the key field value is ignored.)\n\nAre you REALLY sure you want to do this?"
            >
                <span class="fas fa-file-import" aria-hidden="true"></span> Export Format
            </a>
            <a  class="dropdown-item" *ngFor="let name of importTemplateNames; let idx = index;"
                wackadooFileUpload
                eventHandler="{{ eventHandler }}"
                action="bulkImport"
                [parms]="{fileExtension:importTemplateFileExtensions[idx], tifName:name}"
                [validExtensions]="importTemplateFileExtensions[idx]"
                successTitle="File Import Complete: {{name}}"
                confirmTitle="IMPORTANT! You are about to import a large number of resources using this import template: {{name}}"
                confirmMessage="These resources will be ADDED to the list on the {{ eventHandler }} page AND ASSIGNED, if possible, to the appropriate {{assignedToRelatedEventHandler}}. When the import is done, you will probably need to use the tool provided to (re-)assign un-matched resources.\n\nThis is a BULK-ADD operation which WILL generate duplicate entries if the same data is imported multiple times. (This import process does NOT replace existing items!\n\nAre you REALLY sure you want to do this?"
            >
                <span class="fas fa-file-import" aria-hidden="true"></span> {{name}}
            </a>
        </div>
    </button>
    <button 
        *ngIf="methods.includes('bulkImport') && !hasImportTemplates"
        type="button" 
        title="Import"
        data-abbrev=""
        class="btn btn-secondary actionButton" 

        wackadooFileUpload
        eventHandler="{{ eventHandler }}"
        action="bulkImport"
        [parms]="{fileExtension:'txt'}"
        [validExtensions]="'txt'"
        successTitle="File Import Complete"
        confirmTitle="IMPORTANT! You are about to import a large number of resources."
        confirmMessage="These resources will be ADDED to the list on the {{ eventHandler }} page.\n\nThis is a BULK-ADD operation which WILL generate duplicate entries if the same data is imported multiple times. (This import process does NOT replace existing items! Though the format of the file must match what you get from the Export function, the key field value is ignored.)\n\nAre you REALLY sure you want to do this?"
    >
        <span class="fas fa-file-import"></span>
    </button>
    <button type="button" title="Export"    data-abbrev="" class="btn btn-secondary actionButton" (click)="export()"     *ngIf="methods.includes('export')"><span class="fas fa-file-export"></span></button>
    <button type="button" title="Search"    data-abbrev="" class="btn btn-secondary actionButton" (click)="search()"     *ngIf="methods.includes('search') && (screenSize < 575)"><span class="fas fa-search"></span></button>

<!--
    These buttons are instrumentation for testing/debugging EventServerService.fireEvent() errors
 -->
<!--
    <button type="button" title="Force HTTP Error"  data-abbrev="" class="btn btn-secondary actionButton" (click)="forceHttpError()"><span class="fas fa-exclamation-triangle"></span></button>
    <button type="button" title="Force Bad EH Error"  data-abbrev="" class="btn btn-secondary actionButton" (click)="forceBadEHError()"><span class="fas fa-exclamation-triangle"></span></button>
    <button type="button" title="Force Bad Method Error"  data-abbrev="" class="btn btn-secondary actionButton" (click)="forceBadMethodError()"><span class="fas fa-exclamation-triangle"></span></button>
-->
</div>
